import React from 'react';

import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';

import { softAmber, softAmberBackground, softPurple, softPurpleLight } from 'lib/css/colors';

// Match-signal channels the scorer emits, mapped to their short display labels.
const CHANNEL_LABELS = {
  dense: 'Dense',
  sparse: 'Sparse',
  gtin: 'GTIN',
  gtin_ambiguous: 'GTIN (ambiguous)',
  sku_unique: 'MPN',
  sku_ambiguous: 'MPN (ambiguous)',
  brand_match: 'Brand',
  brand_fuzzy_match: 'Brand (fuzzy)',
  pack_match_exact: 'Pack',
};

const AMBIGUOUS_CHANNELS = new Set(['gtin_ambiguous', 'sku_ambiguous']);

// The row of match-signal badges shown under a candidate DP.
function ChannelBadges({ channels }) {
  if (!channels || channels.length === 0) return null;
  return (
    <div className={css(styles.channelBadgeRow)}>
      {channels.map(ch => (
        <span
          key={ch}
          className={css(
            styles.channelBadge,
            AMBIGUOUS_CHANNELS.has(ch) && styles.channelBadgeAmbiguous,
          )}
        >
          {CHANNEL_LABELS[ch] || ch}
        </span>
      ))}
    </div>
  );
}

ChannelBadges.propTypes = {
  channels: PropTypes.arrayOf(PropTypes.string),
};

const styles = StyleSheet.create({
  channelBadgeRow: { display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 0 },
  channelBadge: {
    fontSize: 10,
    fontWeight: 600,
    color: softPurple,
    backgroundColor: softPurpleLight,
    padding: '2px 7px',
    borderRadius: 6,
  },
  channelBadgeAmbiguous: { color: softAmber, backgroundColor: softAmberBackground },
});

export default ChannelBadges;
